<div class="container-fluid mb-3 p-3 dashboard__header">

  <div class="row">
    <div class="col-3">
      <div class="client-menu client-menu-right">
        <button (click)="goToBook();" mat-icon-button>
          <mat-icon>chevron_left</mat-icon>
        </button>
      </div>
    </div>
    <div class="col-6 d-flex align-items-center justify-content-center">
      <img class="img-fluid" src="../assets/Winning_Hands_Logo_Black-300x100.png">
    </div>
    <div class="col-3 justify-content-end d-flex">
      <button [matMenuTriggerFor]="userMenu" mat-button><mat-icon>menu</mat-icon></button>
      <mat-menu #userMenu="matMenu">
        <button (click)="goToBook();" mat-menu-item>
          <mat-icon>today</mat-icon>
          <span>Book a massage</span>
        </button>
        <button (click)="goToLogin();" mat-menu-item>
          <mat-icon>account_circle</mat-icon>
          <span>Therapist login</span>
        </button>
      </mat-menu>
    </div>
  </div>
</div>
<div class="container" style="margin-top:100px;">
  <div class="row">
    <div class="col-12">
      <h1>PRIVACY POLICY</h1>
    </div>
  </div>
</div>


<style>
  [data-custom-class='body'], [data-custom-class='body'] * {
    background: transparent !important;
  }

  [data-custom-class='title'], [data-custom-class='title'] * {
    font-family: Arial !important;
    font-size: 26px !important;
    color: #000000 !important;
  }

  [data-custom-class='subtitle'], [data-custom-class='subtitle'] * {
    font-family: Arial !important;
    color: #595959 !important;
    font-size: 14px !important;
  }

  [data-custom-class='heading_1'], [data-custom-class='heading_1'] * {
    font-family: Arial !important;
    font-size: 19px !important;
    color: #000000 !important;
  }

  [data-custom-class='heading_2'], [data-custom-class='heading_2'] * {
    font-family: Arial !important;
    font-size: 17px !important;
    color: #000000 !important;
  }

  [data-custom-class='body_text'], [data-custom-class='body_text'] * {
    color: #595959 !important;
    font-size: 14px !important;
    font-family: Arial !important;
  }

  [data-custom-class='link'], [data-custom-class='link'] * {
    color: #3030F1 !important;
    font-size: 14px !important;
    font-family: Arial !important;
    word-break: break-word !important;
  }
</style>

<div class="container pb-5">
  <p>Last updated October 02, 2025</p>

  <p>
    This Privacy Notice for Winning Hands Massage Ltd (doing business as Winning Hands Massage Ltd) ('we', 'us', or 'our'), describes how and why we might access, collect, store, use, and/or share ('process') your personal information when you use our services ('Services'), including when you:
  </p>

  <ul>
    <li>
      Visit our website at http://www.winninghandsmassage.com or any website of ours that links to this Privacy Notice
    </li>
    <li>
      Download and use our mobile application (Winning Hands Massage ), or any other application of ours that links to this Privacy Notice
    </li>
    <li>
      Use Onsite Poker massage. Elevate your tournament experience with Winning Hands Massage - the ultimate on site massage app designed for poker players and tournaments.
    </li>
    <li>
      Stay relaxed, maintain sharp focus and keep your edge as professional massage therapists deliver back neck and shoulder treatments to you without ever leaving your seat.
      Download today and play your winning hand!
      Why Players Love It:

      Instant Booking: Request a massage therapist right to your poker table, no need to leave your seat.

      Live Queue Updates: See your place in line and track your spot.

      Your Favourite Therapists: Select preferred professionals for a personalised massage experience.

      Tournament Ready: Designed for the unique pace of poker tournaments and extended sessions.

      Our qualified, professional team specialises in onsite massage and player wellness. Helping you stay relaxed, alert, and ready to play your best game.

      Transform your game. Download Winning Hands Massage today and experience the difference of expert poker massage delivered directly to your seat.
    </li>
    <li>
      Engage with us in other related ways, including any sales, marketing, or events
    </li>
  </ul>
  <p><b>Questions or concerns?</b> Reading this Privacy Notice will help you understand your privacy rights and choices. We are responsible for making decisions about how your personal information is processed. If you do not agree with our policies and practices, please do not use our Services. If you still have any questions or concerns, please contact us at sorayaradford&#64;gmail.com.</p>

  <h3>
    SUMMARY OF KEY POINTS
  </h3>
  <p>
    <i>
      This summary provides key points from our Privacy Notice, but you can find out more details about any of these topics by clicking the link following each key point or by using ourtable of contentsbelow to find the section you are looking for.
    </i>
  </p>

  <p>
    <b>What personal information do we process?</b> When you visit, use, or navigate our Services, we may process personal information depending on how you interact with us and the Services, the choices you make, and the products and features you use. Learn more aboutpersonal information you disclose to us.
  </p>

  <p>
    <b>Do we process any sensitive personal information?</b> Some of the information may be considered 'special' or 'sensitive' in certain jurisdictions, for example your racial or ethnic origins, sexual orientation, and religious beliefs. We do not process sensitive personal information.
  </p>
  <p>
    <b>Do we collect any information from third parties?</b> We do not collect any information from third parties.
  </p>
  <p>
    <b>How do we process your information?</b> We process your information to provide, improve, and administer our Services, communicate with you, for security and fraud prevention, and to comply with law. We may also process your information for other purposes with your consent. We process your information only when we have a valid legal reason to do so. Learn more abouthow we process your information.
  </p>
  <p>
    <b>In what situations and with which parties do we share personal information?</b> We may share information in specific situations and with specific third parties. Learn more aboutwhen and with whom we share your personal information.
  </p>
  <p>
    <b>How do we keep your information safe?</b> We have adequate organisational and technical processes and procedures in place to protect your personal information. However, no electronic transmission over the internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other unauthorised third parties will not be able to defeat our security and improperly collect, access, steal, or modify your information. Learn more abouthow we keep your information safe.
  </p>
  <p>
    <b>What are your rights?</b> Depending on where you are located geographically, the applicable privacy law may mean you have certain rights regarding your personal information. Learn more aboutyour privacy rights.
  </p>
  <p>
    <b>How do you exercise your rights?</b> The easiest way to exercise your rights is by submitting adata subject access request, or by contacting us. We will consider and act upon any request in accordance with applicable data protection laws.
  </p>
  <p>
    Want to learn more about what we do with any information we collect?Review the Privacy Notice in full.
  </p>

  <h3>
    TABLE OF CONTENTS
  </h3>

  <ol>
    <li>WHAT INFORMATION DO WE COLLECT?</li>
    <li>HOW DO WE PROCESS YOUR INFORMATION?</li>
    <li>WHAT LEGAL BASES DO WE RELY ON TO PROCESS YOUR PERSONAL INFORMATION?</li>
    <li>WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</li>
    <li>HOW LONG DO WE KEEP YOUR INFORMATION?</li>
    <li>HOW DO WE KEEP YOUR INFORMATION SAFE?</li>
    <li>DO WE COLLECT INFORMATION FROM MINORS?</li>
    <li>WHAT ARE YOUR PRIVACY RIGHTS?</li>
    <li>CONTROLS FOR DO-NOT-TRACK FEATURES</li>
    <li>DO UNITED STATES RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</li>
    <li>DO WE MAKE UPDATES TO THIS NOTICE?</li>
    <li>HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</li>
    <li>HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?</li>
  </ol>

  <h3>1. WHAT INFORMATION DO WE COLLECT?</h3>
  <h5>Personal information you disclose to us</h5>
  <p><i><b>In Short:</b> We collect personal information that you provide to us.</i></p>
  <p>We collect personal information that you voluntarily provide to us when you express an interest in obtaining information about us or our products and Services, when you participate in activities on the Services, or otherwise when you contact us.</p>
  <p>Personal Information Provided by You. The personal information that we collect depends on the context of your interactions with us and the Services, the choices you make, and the products and features you use. The personal information we collect may include the following:</p>
  <ul>
    <li>names</li>
    <li>phone numbers</li>
  </ul>
  <p><b>Sensitive Information. </b> We do not process sensitive information.</p>
  <p><b>Application Data.</b> If you use our application(s), we also may collect the following information if you choose to provide us with access or permission:</p>
  <ul>
    <li>Push Notifications. We may request to send you push notifications regarding your account or certain features of the application(s). If you wish to opt out from receiving these types of communications, you may turn them off in your device's settings.</li>
  </ul>
  <p>
    This information is primarily needed to maintain the security and operation of our application(s), for troubleshooting, and for our internal analytics and reporting purposes.
  </p>
  <p>
    All personal information that you provide to us must be true, complete, and accurate, and you must notify us of any changes to such personal information.
  </p>
  <h5>
    Information automatically collected

  </h5>

  <p>In Short: Some information — such as your Internet Protocol (IP) address and/or browser and device characteristics — is collected automatically when you visit our Services.</p>

  <p>We automatically collect certain information when you visit, use, or navigate the Services. This information does not reveal your specific identity (like your name or contact information) but may include device and usage information, such as your IP address, browser and device characteristics, operating system, language preferences, referring URLs, device name, country, location, information about how and when you use our Services, and other technical information. This information is primarily needed to maintain the security and operation of our Services, and for our internal analytics and reporting purposes.</p>

  <p>
    The information we collect includes:

  </p>
  <ul>
    <li>
      Log and Usage Data. Log and usage data is service-related, diagnostic, usage, and performance information our servers automatically collect when you access or use our Services and which we record in log files. Depending on how you interact with us, this log data may include your IP address, device information, browser type, and settings and information about your activity in the Services (such as the date/time stamps associated with your usage, pages and files viewed, searches, and other actions you take such as which features you use), device event information (such as system activity, error reports (sometimes called 'crash dumps'), and hardware settings).


    </li>
    <li>
      Location Data. We collect location data such as information about your device's location, which can be either precise or imprecise. How much information we collect depends on the type and settings of the device you use to access the Services. For example, we may use GPS and other technologies to collect geolocation data that tells us your current location (based on your IP address). You can opt out of allowing us to collect this information either by refusing access to the information or by disabling your Location setting on your device. However, if you choose to opt out, you may not be able to use certain aspects of the Services


    </li>
  </ul>

  <h3>HOW DO WE PROCESS YOUR INFORMATION?</h3>
  <p>In Short: We process your information to provide, improve, and administer our Services, communicate with you, for security and fraud prevention, and to comply with law. We process the personal information for the following purposes listed below. We may also process your information for other purposes only with your prior explicit consent.</p>
  <p>
    We process your personal information for a variety of reasons, depending on how you interact with our Services, including:

  </p>
  <ul>
    <li>We process your personal information for a variety of reasons, depending on how you interact with our Services, including:</li>
    <li>To deliver and facilitate delivery of services to the user.&nbsp;We may process your information to provide you with the requested service.</li>
    <li>To respond to user inquiries/offer support to users.&nbsp;We may process your information to respond to your inquiries and solve any potential issues you might have with the requested service.</li>
    <li>To send administrative information to you.&nbsp;We may process your information to send you details about our products and services, changes to our terms and policies, and other similar information.</li>
    <li>To fulfil and manage your orders. We may process your information to fulfil and manage your orders, payments, returns, and exchanges made through the Services.</li>
    <li>To enable user-to-user communications.&nbsp;We may process your information if you choose to use any of our offerings that allow for communication with another user.</li>
    <li>To save or protect an individual's vital interest. We may process your information when necessary to save or protect an individual&rsquo;s vital interest, such as to prevent harm</li>
  </ul>


  <h5>3. WHAT LEGAL BASES DO WE RELY ON TO PROCESS YOUR INFORMATION?</h5>
  <p>In Short: We only process your personal information when we believe it is necessary and we have a valid legal reason (i.e. legal basis) to do so under applicable law, like with your consent, to comply with laws, to provide you with services to enter into or fulfil our contractual obligations, to protect your rights, or to fulfil our legitimate business interests.</p>

  <p>
    <span style="text-decoration: underline;">
      <em>
        <strong>
          If you are located in the EU or UK, this section applies to you.
        </strong>
      </em>
    </span>
  </p>



  <p>
    The General Data Protection Regulation (GDPR) and UK GDPR require us to explain the valid legal bases we rely on in order to process your personal information. As such, we may rely on the following legal bases to process your personal information:

  </p>
  <ul>
    <li>Consent.&nbsp;We may process your information if you have given us permission (i.e. consent) to use your personal information for a specific purpose. You can withdraw your consent at any time. Learn more about&nbsp;withdrawing your consent.</li>
    <li>Performance of a Contract. We may process your personal information when we believe it is necessary to fulfil our contractual obligations to you, including providing our Services or at your request prior to entering into a contract with you.</li>
    <li>Legal Obligations. We may process your information where we believe it is necessary for compliance with our legal obligations, such as to cooperate with a law enforcement body or regulatory agency, exercise or defend our legal rights, or disclose your information as evidence in litigation in which we are involved.</li>
    <li>Vital Interests. We may process your information where we believe it is necessary to protect your vital interests or the vital interests of a third party, such as situations involving potential threats to the safety of any person.</li>
  </ul>

  <p><span style="text-decoration: underline;"><em><strong>If you are located in Canada, this section applies to you.</strong></em></span></p>

  <p>
    We may process your information if you have given us specific permission (i.e. express consent) to use your personal information for a specific purpose, or in situations where your permission can be inferred (i.e. implied consent). You can withdraw your consent at any time.

  </p>

  <p>
    In some exceptional cases, we may be legally permitted under applicable law to process your information without your consent, including, for example:

  </p>

  <ul>
    <li>If collection is clearly in the interests of an individual and consent cannot be obtained in a timely wayFor investigations and fraud detection and prevention</li>
    <li>For business transactions provided certain conditions are met</li>
    <li>If it is contained in a witness statement and the collection is necessary to assess, process, or settle an insurance claim</li>
    <li>For identifying injured, ill, or deceased persons and communicating with next of kinIf we have reasonable grounds to believe an individual has been, is, or may be victim of financial abuse</li>
    <li>If it is reasonable to expect collection and use with consent would compromise the availability or the accuracy of the information and the collection is reasonable for purposes related to investigating a breach of an agreement or a contravention of the laws of Canada or a provinceIf disclosure is required to comply with a subpoena, warrant, court order, or rules of the court relating to the production of records</li>
    <li>If it was produced by an individual in the course of their employment, business, or profession and the collection is consistent with the purposes for which the information was produced</li>
    <li>If the collection is solely for journalistic, artistic, or literary purposesIf the information is publicly available and is specified by the regulations</li>
    <li>We may disclose de-identified information for approved research or statistics projects, subject to ethics oversight and confidentiality commitments</li>
  </ul>

  <h3>4. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</h3>

  <p>In Short: We may share information in specific situations described in this section and/or with the following third parties.</p>

  <p>
    We may need to share your personal information in the following situations:

  </p>

  <ul>
    <li>
      Business Transfers. We may share or transfer your information in connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business to another company.
    </li>
  </ul>

  <h3>5. HOW LONG DO WE KEEP YOUR INFORMATION?</h3>
  <p>In Short: We keep your information for as long as necessary to fulfil the purposes outlined in this Privacy Notice unless otherwise required by law.</p>
  <p>
    We will only keep your personal information for as long as it is necessary for the purposes set out in this Privacy Notice, unless a longer retention period is required or permitted by law (such as tax, accounting, or other legal requirements).

  </p>
  <p>
    When we have no ongoing legitimate business need to process your personal information, we will either delete or anonymise such information, or, if this is not possible (for example, because your personal information has been stored in backup archives), then we will securely store your personal information and isolate it from any further processing until deletion is possible.

  </p>


  <h3>
    6. HOW DO WE KEEP YOUR INFORMATION SAFE?

  </h3>
  <p>
    In Short: We aim to protect your personal information through a system of organisational and technical security measures.

  </p>
  <p>
    We have implemented appropriate and reasonable technical and organisational security measures designed to protect the security of any personal information we process. However, despite our safeguards and efforts to secure your information, no electronic transmission over the Internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other unauthorised third parties will not be able to defeat our security and improperly collect, access, steal, or modify your information. Although we will do our best to protect your personal information, transmission of personal information to and from our Services is at your own risk. You should only access the Services within a secure environment.

  </p>

  <h3>7. DO WE COLLECT INFORMATION FROM MINORS?</h3>
  <p>
    In Short: We do not knowingly collect data from or market to children under 18 years of age or the equivalent age as specified by law in your jurisdiction.

  </p>
  <p>
    We do not knowingly collect, solicit data from, or market to children under 18 years of age or the equivalent age as specified by law in your jurisdiction, nor do we knowingly sell such personal information. By using the Services, you represent that you are at least 18 or the equivalent age as specified by law in your jurisdiction or that you are the parent or guardian of such a minor and consent to such minor dependent’s use of the Services. If we learn that personal information from users less than 18 years of age or the equivalent age as specified by law in your jurisdiction has been collected, we will deactivate the account and take reasonable measures to promptly delete such data from our records. If you become aware of any data we may have collected from children under age 18 or the equivalent age as specified by law in your jurisdiction, please contact us at info&#54;winninghandsmassage.com.

  </p>




  <h3>8. WHAT ARE YOUR PRIVACY RIGHTS?</h3>

  <p>In Short:&nbsp;Depending on your state of residence in the US or in some regions, such as the European Economic Area (EEA), United Kingdom (UK), Switzerland, and Canada, you have rights that allow you greater access to and control over your personal information.&nbsp;You may review, change, or terminate your account at any time, depending on your country, province, or state of residence.</p>
  <p>In some regions (like the EEA, UK, Switzerland, and Canada), you have certain rights under applicable data protection laws. These may include the right (i) to request access and obtain a copy of your personal information, (ii) to request rectification or erasure; (iii) to restrict the processing of your personal information; (iv) if applicable, to data portability; and (v) not to be subject to automated decision-making. If a decision that produces legal or similarly significant effects is made solely by automated means, we will inform you, explain the main factors, and offer a simple way to request human review. In certain circumstances, you may also have the right to object to the processing of your personal information. You can make such a request by contacting us by using the contact details provided in the section 'HOW CAN YOU CONTACT US ABOUT THIS NOTICE?' below.</p>
  <p>We will consider and act upon any request in accordance with applicable data protection laws.&nbsp;</p>
  <p>If you are located in the EEA or UK and you believe we are unlawfully processing your personal information, you also have the right to complain to your Member State data protection authority or&nbsp;UK data protection authority.If you are located in Switzerland, you may contact the Federal Data Protection and Information Commissioner.</p>
  <p>Withdrawing your consent: If we are relying on your consent to process your personal information, which may be express and/or implied consent depending on the applicable law, you have the right to withdraw your consent at any time. You can withdraw your consent at any time by contacting us by using the contact details provided in the section 'HOW CAN YOU CONTACT US ABOUT THIS NOTICE?' below.</p>
  <p>However, please note that this will not affect the lawfulness of the processing before its withdrawal nor, when applicable law allows, will it affect the processing of your personal information conducted in reliance on lawful processing grounds other than consent.</p>
  <p>If you have questions or comments about your privacy rights, you may email us at sorayaradford&amp;#54;gmail.com.</p>

  <h3>9. CONTROLS FOR DO-NOT-TRACK FEATURES</h3>
  <p>Most web browsers and some mobile operating systems and mobile applications include a Do-Not-Track ('DNT') feature or setting you can activate to signal your privacy preference not to have data about your online browsing activities monitored and collected. At this stage, no uniform technology standard for recognising and implementing DNT signals has been finalised. As such, we do not currently respond to DNT browser signals or any other mechanism that automatically communicates your choice not to be tracked online. If a standard for online tracking is adopted that we must follow in the future, we will inform you about that practice in a revised version of this Privacy Notice.</p>
  <p>California law requires us to let you know how we respond to web browser DNT signals. Because there currently is not an industry or legal standard for recognising or honouring DNT signals, we do not respond to them at this time.</p>

  <h3>10. DO UNITED STATES RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</h3>
  <p>
    In Short: If you are a resident of California, Colorado, Connecticut, Delaware, Florida, Indiana, Iowa, Kentucky, Maryland, Minnesota, Montana, Nebraska, New Hampshire, New Jersey, Oregon, Rhode Island, Tennessee, Texas, Utah, or Virginia, you may have the right to request access to and receive details about the personal information we maintain about you and how we have processed it, correct inaccuracies, get a copy of, or delete your personal information. You may also have the right to withdraw your consent to our processing of your personal information. These rights may be limited in some circumstances by applicable law. More information is provided below.

  </p>
  <h5>
    Categories of Personal Information We Collect

  </h5>
  <p>
    The table below shows the categories of personal information we have collected in the past twelve (12) months. The table includes illustrative examples of each category and does not reflect the personal information we collect from you. For a comprehensive inventory of all personal information we process, please refer to the section 'WHAT INFORMATION DO WE COLLECT?'

  </p>


  <table>
    <tbody>
      <tr>
        <td>Identifiers</td>
        <td>
          Contact details, such as real name, alias, postal address, telephone or mobile contact number, unique personal identifier, online identifier, Internet Protocol address, email address, and account name

        </td>
        <td>NO</td>
      </tr>
      <tr>
        <td>B. Personal information as defined in the California Customer Records statute</td>
        <td>
          Name, contact information, education, employment, employment history, and financial information

        </td>
        <td>YES</td>
      </tr>
      <tr>
        <td>
          C. Protected classification characteristics under state or federal law

        </td>
        <td>
          Gender, age, date of birth, race and ethnicity, national origin, marital status, and other demographic data

        </td>
        <td>NO</td>
      </tr>
      <tr>
        <td>D. Commercial information</td>
        <td>Transaction information, purchase history, financial details, and payment information</td>
        <td>NO</td>
      </tr>
      <tr>
        <td>E. Biometric information</td>
        <td>Fingerprints and voiceprints</td>
        <td>NO</td>
      </tr>
      <tr>
        <td>F. Internet or other similar network activity</td>
        <td>Browsing history, search history, online behaviour, interest data, and interactions with our and other websites, applications, systems, and advertisements</td>
        <td>NO</td>
      </tr>
      <tr>
        <td>G. Geolocation data</td>
        <td>Device location</td>
        <td>NO</td>
      </tr>
      <tr>
        <td>H. Audio, electronic, sensory, or similar information</td>
        <td>Images and audio, video or call recordings created in connection with our business activities</td>
        <td>NO</td>
      </tr>
      <tr>
        <td>I. Professional or employment-related information</td>
        <td>Business contact details in order to provide you our Services at a business level or job title, work history, and professional qualifications if you apply for a job with us</td>
        <td>NO</td>
      </tr>
      <tr>
        <td>J. Education Information</td>
        <td>Student records and directory information</td>
        <td>NO</td>
      </tr>
      <tr>
        <td>K. Inferences drawn from collected personal information</td>
        <td>Inferences drawn from any of the collected personal information listed above to create a profile or summary about, for example, an individual’s preferences and characteristics</td>
        <td>NO</td>
      </tr>
      <tr>
        <td>L. Sensitive personal Information</td>
        <td></td>
        <td>NO</td>
      </tr>
    </tbody>
  </table>


  <p>We may also collect other personal information outside of these categories through instances where you interact with us in person, online, or by phone or mail in the context of:</p>
  <ul>
    <li>Receiving help through our customer support channels;</li>
    <li>Participation in customer surveys or contests; and</li>
    <li>Facilitation in the delivery of our Services and to respond to your inquiries.</li>
  </ul>
  <p>We will use and retain the collected personal information as needed to provide the Services or for:</p>
  <ul>
    <li>Category B - 1 year</li>
  </ul>
  <p>We may also collect other personal information outside of these categories through instances where you interact with us in person, online, or by phone or mail in the context of:</p>
  <ul>
    <li>Receiving help through our customer support channels;</li>
    <li>Participation in customer surveys or contests; and</li>
    <li>Facilitation in the delivery of our Services and to respond to your inquiries.</li>
  </ul>
  <p>We will use and retain the collected personal information as needed to provide the Services or for:</p>
  <ul>
    <li>Category B - 1 year</li>
  </ul>
  <h5>Sources of Personal Information</h5>
  <p>Learn more about the sources of personal information we collect in 'WHAT INFORMATION DO WE COLLECT?'</p>
  <h5>How We Use and Share Personal Information</h5>
  <p>Learn more about how we use your personal information in the section, 'HOW DO WE PROCESS YOUR INFORMATION?'</p>
  <p><strong>Will your information be shared with anyone else?</strong></p>
  <p>We may disclose your personal information with our service providers pursuant to a written contract between us and each service provider. Learn more about how we disclose personal information to in the section, 'WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?'&nbsp;</p>
  <p>We may use your personal information for our own business purposes, such as for undertaking internal research for technological development and demonstration. This is not considered to be 'selling' of your personal information.</p>
  <p>We have not disclosed, sold, or shared any personal information to third parties for a business or commercial purpose in the preceding twelve (12) months. We&nbsp;will not sell or share personal information in the future belonging to website visitors, users, and other consumers.</p>
  <h5>Your Rights</h5>
  <p>You have rights under certain US state data protection laws. However, these rights are not absolute, and in certain cases, we may decline your request as permitted by law.</p>
  <p>These rights include:&nbsp;</p>
  <ul>
    <li>Right to know whether or not we are processing your personal data</li>
    <li>Right to access&nbsp;your personal data</li>
    <li>Right to correct&nbsp;inaccuracies in your personal data</li>
    <li>Right to request the deletion of your personal data</li>
    <li>Right to obtain a copy&nbsp;of the personal data you previously shared with us</li>
    <li>Right to non-discrimination for exercising your rights</li>
    <li>Right to opt out of the processing of your personal data if it is used for targeted advertising (or sharing as defined under California&rsquo;s privacy law), the sale of personal data, or profiling in furtherance of decisions that produce legal or similarly significant effects ('profiling')</li>
  </ul>
  <p>Depending upon the state where you live, you may also have the following rights:</p>
  <ul>
    <li>Right to access the categories of personal data being processed (as permitted by applicable law, including the privacy law in Minnesota)</li>
    <li>Right to obtain a list of the categories of third parties to which we have disclosed personal data (as permitted by applicable law, including the privacy law in California, Delaware, and Maryland)</li>
    <li>Right to obtain a list of specific third parties to which we have disclosed personal data (as permitted by applicable law, including the privacy law in Minnesota and Oregon)</li>
    <li>Right to review, understand, question, and correct how personal data has been profiled (as permitted by applicable law, including the privacy law in Minnesota)</li>
    <li>Right to limit use and disclosure of sensitive personal data (as permitted by applicable law, including the privacy law in California)</li>
    <li>Right to opt out of the collection of sensitive data and personal data collected through the operation of a voice or facial recognition feature (as permitted by applicable law, including the privacy law in Florida)</li>
  </ul>
  <p>&nbsp;</p>
  <h5>How to Exercise Your Rights</h5>
  <p>To exercise these rights, you can contact us by submitting a&nbsp;data subject access request, by emailing us at info&amp;#54;winninghandsmassage.com, or by referring to the contact details at the bottom of this document.</p>
  <p>Under certain US state data protection laws, you can designate an authorised agent to make a request on your behalf. We may deny a request from an authorised agent that does not submit proof that they have been validly authorised to act on your behalf in accordance with applicable laws.</p>
  <h5>Request Verification</h5>
  <p>Upon receiving your request, we will need to verify your identity to determine you are the same person about whom we have the information in our system. We will only use personal information provided in your request to verify your identity or authority to make the request. However, if we cannot verify your identity from the information already maintained by us, we may request that you provide additional information for the purposes of verifying your identity and for security or fraud-prevention purposes.</p>
  <p>If you submit the request through an authorised agent, we may need to collect additional information to verify your identity before processing your request and the agent will need to provide a written and signed permission from you to submit such request on your behalf.</p>
  <h5>Appeals</h5>
  <p>Under certain US state data protection laws, if we decline to take action regarding your request, you may appeal our decision by emailing us at sorayaradford&amp;#54;gmail.com. We will inform you in writing of any action taken or not taken in response to the appeal, including a written explanation of the reasons for the decisions. If your appeal is denied, you may submit a complaint to your state attorney general.</p>
  <h5>California 'Shine The Light' Law</h5>
  <p>California Civil Code Section 1798.83, also known as the 'Shine The Light' law, permits our users who are California residents to request and obtain from us, once a year and free of charge, information about categories of personal information (if any) we disclosed to third parties for direct marketing purposes and the names and addresses of all third parties with which we shared personal information in the immediately preceding calendar year. If you are a California resident and would like to make such a request, please submit your request in writing to us by using the contact details provided in the section 'HOW CAN YOU CONTACT US ABOUT THIS NOTICE?'</p>

  <h3>11. DO WE MAKE UPDATES TO THIS NOTICE?</h3>
  <p>In Short:&nbsp;Yes, we will update this notice as necessary to stay compliant with relevant laws.</p>
  <p>We may update this Privacy Notice from time to time. The updated version will be indicated by an updated 'Revised' date at the top of this Privacy Notice. If we make material changes to this Privacy Notice, we may notify you either by prominently posting a notice of such changes or by directly sending you a notification. We encourage you to review this Privacy Notice frequently to be informed of how we are protecting your information.</p>
  <h3>12. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</h3>
  <p>If you have questions or comments about this notice, you may email us at info&amp;#54;winninghandsmassage.com or&nbsp;contact us by post at:Winning Hands Massage Ltd1096 Uxbridge RoadHayesLondon, London UB4 8QHUnited Kingdom</p>
  <h3>13. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?</h3>
  <p>Based on the applicable laws of your country or state of residence in the US, you may have the right to request access to the personal information we collect from you, details about how we have processed it, correct inaccuracies, or delete your personal information. You may also have the right to withdraw your consent to our processing of your personal information. These rights may be limited in some circumstances by applicable law. To request to review, update, or delete your personal information, please fill out and submit a&nbsp;data subject access request.</p>



</div>
